import { MPIN_TABLE_DATA, MPIN_TABLE_DATA_SUCCESS } from "../../actions/actionTypes";

interface DDPServiceState {
  mpinTableData: any;

}

const initialState: DDPServiceState = {
  mpinTableData: [],
};

const ddpServiceReducer = (state = initialState, action: { type: string; payload?: any }): SiteOfServiceState => {
  switch (action.type) {
    case MPIN_TABLE_DATA_SUCCESS:
      return {
        ...state,
        mpinTableData: action.payload,
      };
    case MPIN_TABLE_DATA:
      return {
        ...state,
        mpinTableData: action.payload,
      };
     
    default:
      return state;
  }
};

export default ddpServiceReducer;